import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import FloatingBanner from 'components/FloatingBanner';
import {
  FLOATING_BANBER_COLORS,
  FloatingBannerProps,
} from 'components/FloatingBanner/FloatingBanner.component';
import ArrowrightIcon from 'icons/Arrowright.icon';
import XIcon from 'icons/X.icon';
import { Button } from 'ncoded-component-library';
import SparklesIcon from 'icons/Sparkles.icon';

import './GuideCard.styles.scss';

type GuideCardProps = {
  className?: string;
  stepNumber?: number;
  totalSteps?: number;
  title: string;
  description: string;
  gif?: string;
  onNext?: () => void;
  onBack?: () => void;
} & FloatingBannerProps;

const GuideCard: React.FC<GuideCardProps> = (props) => {
  const {
    className,
    title,
    description,
    totalSteps,
    stepNumber = 1,
    onNext,
    onBack,
    onClose,
    ...rest
  } = props;

  const classes = classNames('guide-card', className);

  const { t } = useTranslation();

  return (
    <FloatingBanner
      showOnPhablet
      hasOverlay
      className={classes}
      color={FLOATING_BANBER_COLORS.WHITE}
      onClose={onClose}
      {...rest}
    >
      <div className="guide-card__content">
        <p className="guide-card__title">
          <span className="guide-card__icon">
            <SparklesIcon />
          </span>
          {t(title)}
        </p>
        <p className="guide-card__description">{t(description)}</p>

        {!!totalSteps && (
          <div className="guide-card__footer">
            <p>
              {t('currentOfTotal', {
                current: stepNumber,
                total: totalSteps,
              })}
            </p>

            <div className="guide-card__actions">
              <Button
                variant="link"
                disabled={stepNumber <= 1}
                onClick={onBack}
              >
                {t('back')}
              </Button>

              {stepNumber < totalSteps ? (
                <Button
                  icon={ArrowrightIcon}
                  variant="outline"
                  iconPosition="right"
                  onClick={onNext}
                >
                  {t('next')}
                </Button>
              ) : (
                <Button
                  icon={XIcon}
                  variant="outline"
                  iconPosition="right"
                  onClick={onClose}
                >
                  {t('close')}
                </Button>
              )}
            </div>
          </div>
        )}
      </div>
    </FloatingBanner>
  );
};

export default GuideCard;
